import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setAiFieldConfig: YJSChangeHandler<
  DatabaseChangeType.SET_AI_FIELD_CONFIG
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    if (field) {
      field.aiFieldConfig = change.aiFieldConfig;
    }
  });
};
